import './js-sdk/src';
import React from 'react';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';

import ErrorBoundary from './components/ErrorBoundaries/GeneralError';
import VirtualWaiting from './VirtualWaitingRoom';
import enLocale from './locales/en';
import store from './store';

import './PatientCallBase.css';

export const PatientVirtualWaitingRoom = () => (
  <Provider store={store}>
    <IntlProvider messages={enLocale} locale="en">
      <ErrorBoundary>
        {/* https://tigertext.atlassian.net/browse/TMG-837 */}
        {/* @ts-expect-error */}
        <VirtualWaiting />
      </ErrorBoundary>
    </IntlProvider>
  </Provider>
);

export default PatientVirtualWaitingRoom;
